export default function filenameIsSvg(filename: string): boolean {
    return filename.toLowerCase().endsWith('.svg');
}
